/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Toast_StartInputs */

const en_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue List Export`)
};

const fr_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation de la liste des dialogues`)
};

const de_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialoglistenexport`)
};

const it_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione elenco dialoghi`)
};

const ru_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт списка диалогов`)
};

const es_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de lista de diálogos`)
};

const zh_cn2_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对话列表导出`)
};

const ja_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイアログリストのエクスポート`)
};

const hi_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद सूची निर्यात`)
};

const pt_pt2_dialogue_list_export_toast_start = /** @type {(inputs: Dialogue_List_Export_Toast_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar lista de diálogos`)
};

/**
* | output |
* | --- |
* | "Dialogue List Export" |
*
* @param {Dialogue_List_Export_Toast_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_toast_start = /** @type {((inputs?: Dialogue_List_Export_Toast_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Toast_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_toast_start(inputs)
	if (locale === "de") return de_dialogue_list_export_toast_start(inputs)
	if (locale === "it") return it_dialogue_list_export_toast_start(inputs)
	if (locale === "ru") return ru_dialogue_list_export_toast_start(inputs)
	if (locale === "es") return es_dialogue_list_export_toast_start(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_toast_start(inputs)
	if (locale === "ja") return ja_dialogue_list_export_toast_start(inputs)
	if (locale === "hi") return hi_dialogue_list_export_toast_start(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_toast_start(inputs)
	return en_dialogue_list_export_toast_start(inputs)
});